export interface IBusinessUnit {
  businessUnitTypeId: number;
  name: string;
  netSuiteDepartmentId: number | null;
  netSuiteARAccountId: number | null;
  netSuiteARAccountName: string | null;
}
// Following the pattern, but I expect I'll change this pattern later
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IBusinessUnit = {
  getDefault(): IBusinessUnit {
    return {
      name: '',
      businessUnitTypeId: 0,
      netSuiteDepartmentId: 0,
      netSuiteARAccountId: 0,
      netSuiteARAccountName: '',
    };
  },
};
